/** Header chrome for the task edit/create modal. */
import { Box, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useT } from '@/i18n/useT';

export function TaskModalHeader({
  title,
  onTitleChange,
  titleInputRef,
  onClose,
}) {
  const t = useT();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1,
        px: 2,
        pt: 2,
        pb: 0,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 0.5,
          flex: 1,
          minWidth: 0,
        }}
      >
        <IconButton
          size="small"
          onClick={() => titleInputRef.current?.focus()}
          aria-label={t('taskform.editTitle', 'Titel bewerken')}
          title={t('taskform.editTitle', 'Titel bewerken')}
          sx={{ mt: 0.25, color: 'text.subtle', flexShrink: 0 }}
        >
          <EditOutlinedIcon fontSize="small" />
        </IconButton>
        <TextField
          id="title"
          name="title"
          inputRef={titleInputRef}
          autoFocus
          variant="standard"
          placeholder={t('taskform.titlePlaceholder', 'Taaktitel')}
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
          fullWidth
          inputProps={{ 'aria-label': t('taskform.titleLabel', 'Title:') }}
          InputProps={{
            disableUnderline: true,
            sx: { fontSize: '1.15em', fontWeight: 700 },
          }}
        />
      </Box>
      <IconButton
        size="small"
        onClick={onClose}
        aria-label={t('modal.close', 'Close')}
        title={t('modal.close', 'Close')}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
